export const getRequiredErrorMessage = (fieldName) => {
    return `${fieldName} is required.`
}

export const getInvalidMessage = (fieldName) => {
    return `Please enter a valid ${fieldName || 'value'}.`;
}